import React, { useState, useEffect } from 'react';
import momentumLogo from '../../assets/images/MomentumLogo.png';
import { useNavigate, useLocation } from 'react-router-dom';
import HubTaskbar from './HubTaskbar';
import '../../assets/css/Hub.css';

function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const mockHistory = [
  { guid: '1a2b3c', title: 'How to reset my password?' },
  { guid: '2b3c4d', title: 'Pricing details' },
  { guid: '3c4d5e', title: 'Contact support' },
];

type AMPSidebarProps = {
  showSidebarContent?: boolean;
  taskbarCompact?: boolean;
  pagename?: string;
  collapsed?: boolean;
  onCollapseToggle?: (collapsed: boolean) => void;
};

export default function AMPSidebar(props: AMPSidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [history, setHistory] = useState<any[]>([]);
    useEffect(() => {
      const fetchHistory = async () => {
        try {
          const token = localStorage.getItem('authToken');
          const response = await fetch('https://momentummyamp-stage.insurancegig.com/api/recent-history', {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
          const data = await response.json();
          if (Array.isArray(data)) {
             setHistory(data);
          }
        } catch (error) {
          setHistory([]);
        }
      };
      fetchHistory();
    }, []);
  const { showSidebarContent = true, taskbarCompact = false, collapsed: collapsedProp, onCollapseToggle } = props || {};
  const [collapsed, setCollapsed] = useState<boolean>(!!collapsedProp);
 
  const shouldShowSidebarContent = location.pathname.startsWith('/supportbot') || location.pathname.startsWith('/amp/');
  const isAmpsRoute = location.pathname.startsWith('/amps');

  useEffect(() => {
    if (isAmpsRoute) {
      setCollapsed(true);
    } else if (typeof collapsedProp === 'boolean') {
      setCollapsed(collapsedProp);
    }
  }, [collapsedProp, isAmpsRoute]);

  const toggleCollapsed = () => {
    const next = !collapsed;
    setCollapsed(next);
    if (onCollapseToggle) onCollapseToggle(next);
  };

  const handleNewChat = () => {
    const newGuid = generateGuid();
    navigate(`/supportbot/${newGuid}`);
  };

  const handleHistoryClick = (guid: string) => {
    navigate(`/supportbot/${guid}`);
  };

  const handleMomentumAMPClick = () => {
    navigate('/amps');
  };

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  // If not supportbot route, return only taskbar wrapped in proper container
  if (!shouldShowSidebarContent) {
    return (
      <aside className="amp-sidebar-theme taskbar-only">
        <div className="amp-sidebar-layout">
          <HubTaskbar compact={taskbarCompact} collapsed={false} />
        </div>
      </aside>
    );
  }

  return (
    <aside className={`amp-sidebar-theme${collapsed ? ' collapsed' : ''}`}>
      <div className="amp-sidebar-layout">
        <HubTaskbar compact={taskbarCompact} collapsed={collapsed} onToggleCollapse={toggleCollapsed} />
        <div className={`amp-sidebar-main${collapsed ? ' collapsed' : ''}`}>
          {showSidebarContent ? (
            <div className="amp-sidebar-inner">
      
              <div className="amp-sidebar-search-wrap">
                <input
                  type="text"
                  className="amp-sidebar-search"
                  placeholder="Search conversations..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>

              <button
                className="amp-sidebar-btn"
                title="Start New Conversation"
                onClick={handleNewChat}
              >
                <span className="amp-sidebar-btn-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                </span>
                <span>New Conversation</span>
              </button>

              <div className="amp-sidebar-history-section">
                <div className="amp-sidebar-history-title">Recent Conversations</div>
                <ul className="amp-sidebar-history-list">
                  {history.filter(h => h.Question.toLowerCase().includes(search.toLowerCase())).map(h => (
                    <li key={h.ConversationId}>
                      <button
                        className={`amp-sidebar-history-btn${location.pathname.includes(h.ConversationId) ? ' active' : ''}`}
                        onClick={() => handleHistoryClick(h.ConversationId)}
                        title={h.Question}
                      >
                        <span className="amp-sidebar-history-btn-icon">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b46c1" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                        </span>
                        <span className="amp-sidebar-history-text">{h.Question}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </aside>
  );
}
